<template>
  <div id="app" class="app-container">
    <!-- <navigation>
      <router-view></router-view>
    </navigation> -->
      <router-view></router-view>
    <VersionUpdate ref="VersionUpdate"></VersionUpdate>
    <!-- icon 用来预加载icon -->
    <div style="position: absolute;  z-index: -9999;  opacity: 0;"><md-icon name="sort"></md-icon></div>
  </div>
</template>


<script>
import { getVersion } from "@/api/public";
import { isAndroid,isIOS } from "@/utils/validate"
import VersionUpdate from "@/components/VersionUpdate"
export default {
  name: "app",
  components:{VersionUpdate},
  data() {
    return {
      isApp:window.plus ? true : false
    };
  },
  created() {},
  mounted() {
    var that = this
    document.addEventListener('plusready', function () {
      var activeVersion = String(plus.runtime.version)
      that.getActiveVersion(activeVersion)
    });
    // that.getActiveVersion("2.3")
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    // 更新版本
    getActiveVersion(activeVersion){
      getVersion({type:3}).then(res=>{
        if(res.code == 200 ){
          if(res.data.version != activeVersion){
            this.$refs.VersionUpdate.showPop(res.data)
          }
        }
      })
    }
  }
};
</script>

<style lang="less">
html,
body {
  // height: 100%;
  background-color: #f1f1f1;
}
#app {
  height: 100%;
  overflow: hidden;
  // overflow: auto;
  position: relative;
  font-family: "sans-serif,Avenir", Helvetica, Arial, ;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #404040;
  font-size: 0.24rem;
  background-color: #e4e4e4;
  box-sizing: border-box;
}
.ellipsis-1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.fwb {
  font-weight: bold;
}
input {
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
}
em {
  font-style: normal;
}
</style>
